/**
 * Main order status used in DB
 */
export enum OrderPositionStatus {
    STATUS_PENDING = 'PENDING',
    STATUS_IN_WORK = 'IN_WORK',
    STATUS_COMPLETED = 'COMPLETED',
}

/**
 * Order status flow:
 * | FROM      | TO        | TRIGGER                                   |
 * |-----------|-----------|-------------------------------------------|
 * | -         | PENDING   | Every new order is set to NEW by default  |
 * | PENDING   | IN_WORK   | Clicked print sticker button              |
 * | IN_WORK   | COMPLETED | Clicked "complete" button                 |
 */
const eligibleOrderPositionStatusTransition: { from: OrderPositionStatus; to: OrderPositionStatus }[] = [
    { from: undefined, to: OrderPositionStatus.STATUS_PENDING },
    { from: OrderPositionStatus.STATUS_PENDING, to: OrderPositionStatus.STATUS_IN_WORK },
    { from: OrderPositionStatus.STATUS_IN_WORK, to: OrderPositionStatus.STATUS_COMPLETED },
];

export function orderPositionCanChangeStatus(from: OrderPositionStatus, to: OrderPositionStatus): boolean {
    return eligibleOrderPositionStatusTransition.some(transition => transition.from === from && transition.to === to);
}

const orderPositionStatusLabel: Record<OrderPositionStatus, string> = {
    [OrderPositionStatus.STATUS_PENDING]: 'В ожидании',
    [OrderPositionStatus.STATUS_IN_WORK]: 'В работе',
    [OrderPositionStatus.STATUS_COMPLETED]: 'Выполнена',
};

export function orderPositionStatusToLabel(status: OrderPositionStatus): string {
    return orderPositionStatusLabel[status];
}
